// extracted by mini-css-extract-plugin
export default {"appIcon":"m8HJ_6GG1z"};